const SET_DANH_SACH_NHOM_CONG_VIEC = (state, danhSachNhomCongViec) => {
  state.danhSachNhomCongViec = danhSachNhomCongViec;
};

const SET_CHI_TIET_NHOM_CONG_VIEC = (state, chiTietNhomCongViec) => {
  state.chiTietNhomCongViec = chiTietNhomCongViec;
};

const LAY_DANH_SACH_MAU_DU_THAO = (state, danhSachMauDuThao) => {
  state.danhSachMauDuThao = danhSachMauDuThao;
};
const SET_CHI_TIET_NHOM_CONG_VIEC_TRONG_HT = (
  state,
  chiTietNhomCongViecTrongHeThong
) => {
  state.chiTietNhomCongViecTrongHeThong = chiTietNhomCongViecTrongHeThong;
};

const CHI_TIET_MAU_DU_THAO = (state, chiTietMauDuThao) => {
  state.chiTietMauDuThao = chiTietMauDuThao;
};
const DONG_BO_DANH_MUC_CHUNG = (state, dongBoDanhMucChung) => {
  state.dongBoDanhMucChung = dongBoDanhMucChung;
};
const DONG_BO_CAN_BO = (state, dongBoCanBo) => {
  state.dongBoCanBo = dongBoCanBo;
};
const SEARCH_CAU_HINH = (state, cauHinh) => {
  let sortCauHinh = cauHinh;
  let temp = cauHinh[1];
  sortCauHinh[1] = sortCauHinh[3];
  sortCauHinh[3] = temp;
  temp = cauHinh[2];
  sortCauHinh[2] = sortCauHinh[4];
  sortCauHinh[4] = temp;
  sortCauHinh[5] = cauHinh[5];
  state.cauHinh = sortCauHinh?.filter(item => item);
};
const DANH_SACH_DE_MUC = (state ,danhSachDeMuc) => {
  state.danhSachDeMuc = danhSachDeMuc
}
const CURRENT_PHONG_BAN_LINH_VUC  = (state ,currentPhongBanLinhVuc) => {
  state.currentPhongBanLinhVuc =currentPhongBanLinhVuc
}

const DANH_SACH_LINH_VUC = (state ,danhSachLinhVuc) => {
  state.danhSachLinhVuc = danhSachLinhVuc;
}
const THEM_LINH_VUC = (state, themLinhVuc) => {
  state.themLinhVuc = themLinhVuc;
};
const DANH_SACH_PHONG_BAN = (state, getDanhSachPhongBan) => {
  state.getDanhSachPhongBan = getDanhSachPhongBan;
}
const DANH_SACH_NOP_LUU = (state, danhSachNopLuu) => {
  state.danhSachNopLuu = danhSachNopLuu
}

const DANH_SACH_DON_VI_NHAN = (state, danhSachDonViNhan) => {
  state.danhSachDonViNhan = danhSachDonViNhan
}

const DANH_SACH_DON_VI_GUI = (state, danhSachDonViGui) => {
  state.danhSachDonViGui = danhSachDonViGui
}
const DANH_SACH_UY_QUYEN = (state, danhSachUyQuyen) => {
  state.danhSachUyQuyen = danhSachUyQuyen;
};
const DANH_SACH_NGUOI_UY_QUYEN = (state, danhSachNguoiUyQuyen) => {
  state.danhSachNguoiUyQuyen = danhSachNguoiUyQuyen;
}

export default {
  SET_DANH_SACH_NHOM_CONG_VIEC,
  SET_CHI_TIET_NHOM_CONG_VIEC,
  LAY_DANH_SACH_MAU_DU_THAO,
  SET_CHI_TIET_NHOM_CONG_VIEC_TRONG_HT,
  CHI_TIET_MAU_DU_THAO,
  SEARCH_CAU_HINH,
  DANH_SACH_DE_MUC,
  CURRENT_PHONG_BAN_LINH_VUC,
  DANH_SACH_LINH_VUC,
  THEM_LINH_VUC,
  DANH_SACH_PHONG_BAN,
  DANH_SACH_NOP_LUU,
  DANH_SACH_DON_VI_NHAN,
  DANH_SACH_DON_VI_GUI,
  DANH_SACH_UY_QUYEN,
  DANH_SACH_NGUOI_UY_QUYEN,
  DONG_BO_DANH_MUC_CHUNG,
  DONG_BO_CAN_BO
};
